<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="title" epub:type="titlepage">
<header><h1 class="title" id="title"><span aria-label=" Page x. " epub:type="pagebreak" id="page_x" role="doc-pagebreak">THE WEB<br/><span class="small">OF</span><br/>MEANING</span></h1></header>
<p class="subtitle">INTEGRATING SCIENCE AND TRADITIONAL WISDOM TO FIND OUR PLACE IN THE UNIVERSE</p>
<p class="author">JEREMY LENT</p>
<figure class="pub"><img alt="" class="w30" src="images/title.jpg"/></figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?572aea50